import { Injectable } from '@angular/core';

@Injectable()
export class UtilityService {
    getBrandLogoFileName(brandName: string) {
        let fileName: string = '';
        switch(brandName) {
            case 'Anthem Blue Cross':
                fileName = 'top-logo-abc.svg';
                break;
            case 'Anthem Blue Cross Blue Shield':
                fileName = 'top-logo-abcbs.svg';
                break;
            case 'Empire Blue Cross':
                fileName = 'top-logo-ebc.svg';
                break;
            case 'Empire Blue Cross Blue Shield':
                fileName = 'top-logo-ebcbs.svg';
                break;
        }
        return fileName;
    }
}
